module.exports = __webpack_public_path__ + "static/media/s2@2x-min.b9b15849.png";